"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toClipboard = toClipboard;
function toClipboard(text) {
    let temporaryTextArea = document.createElement("textarea");
    // Place in top-left corner of screen regardless of scroll position.
    temporaryTextArea.style.position = "fixed";
    temporaryTextArea.style.top = "0";
    temporaryTextArea.style.left = "0";
    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    temporaryTextArea.style.width = "2em";
    temporaryTextArea.style.height = "2em";
    // We don't need padding, reducing the size if it does flash render.
    temporaryTextArea.style.padding = "0";
    // Clean up any borders.
    temporaryTextArea.style.border = "none";
    temporaryTextArea.style.outline = "none";
    temporaryTextArea.style.boxShadow = "none";
    // Avoid flash of white box if rendered for any reason.
    temporaryTextArea.style.background = "transparent";
    temporaryTextArea.value = text;
    document.body.appendChild(temporaryTextArea);
    temporaryTextArea.select();
    let successful = document.execCommand("copy");
    let msg = successful ? "successful" : "unsuccessful";
    console.log("Copying text command was " + msg);
    document.body.removeChild(temporaryTextArea);
}
//# sourceMappingURL=clipboard.js.map